// Mock data for Tribal Dash Cannabis Dispensary

/** Canonical store hours. */
export const storeHoursLines = [
  { days: 'Monday – Wednesday', hours: '7 AM – 9 PM ET' },
  { days: 'Thursday – Saturday', hours: '7 AM – 10 PM ET' },
  { days: 'Sunday', hours: '8 AM – 8 PM ET' },
];

/** One-line summary for compact UI (e.g. store picker). */
export const storeHoursShort =
  'Mon–Wed 7 AM–9 PM, Thu–Sat 7 AM–10 PM, Sun 8 AM–8 PM (ET)';

export const locations = [
  {
    id: 1,
    name: 'Cloud 9',
    address: '42 Montauk Hwy, Southampton, NY 11968',
    phone: '(631) 461-8826',
    hours: storeHoursShort,
    status: 'open'
  }
];

export const categories = [
  { id: 1, name: 'Flower', slug: 'flower', icon: '🌿' },
  { id: 2, name: 'Pre-Rolls', slug: 'pre-rolls', icon: '🚬' },
  { id: 3, name: 'Edibles', slug: 'edibles', icon: '🍬' },
  { id: 4, name: 'Vaporizers', slug: 'vaporizers', icon: '💨' },
  { id: 5, name: 'Concentrates', slug: 'concentrates', icon: '💎' },
  { id: 6, name: 'Tinctures', slug: 'tinctures', icon: '💧' },
  { id: 7, name: 'Topicals', slug: 'topicals', icon: '🧴' },
  { id: 8, name: 'Accessories', slug: 'accessories', icon: '🔧' }
];

export const deals = [
  {
    id: 1,
    title: 'Happy Hour Special',
    description: '10% OFF orders $150+ Mon-Fri 9AM-12PM',
    image: 'https://images.unsplash.com/photo-1616690002554-b53821496f45?w=400',
    link: '/specials/happy-hour'
  },
  {
    id: 2,
    title: 'Buy 2 Get 1 Free',
    description: 'Select Vape Cartridges',
    image: 'https://images.unsplash.com/photo-1579165466814-e646cfa4a3be?w=400',
    link: '/specials/vape-deal'
  },
  {
    id: 3,
    title: 'Flower Friday',
    description: '20% OFF All Premium Flower',
    image: 'https://images.unsplash.com/photo-1616690001922-700ad8a4a005?w=400',
    link: '/specials/flower-friday'
  },
  {
    id: 4,
    title: 'Edibles Bundle',
    description: 'Buy 3 for $60',
    image: 'https://images.unsplash.com/photo-1617627191898-1408bf607b4d?w=400',
    link: '/specials/edibles-bundle'
  },
  {
    id: 5,
    title: 'New Customer Deal',
    description: '15% OFF Your First Order',
    image: 'https://images.unsplash.com/photo-1649424219467-4dd79e189be2?w=400',
    link: '/specials/new-customer'
  },
  {
    id: 6,
    title: 'Loyalty Rewards',
    description: 'Earn Points on Every Purchase',
    image: 'https://images.unsplash.com/photo-1622704776938-bed6cd156e04?w=400',
    link: '/specials/loyalty'
  }
];

export const products = [
  {
    id: 1,
    name: 'Purple Haze',
    category: 'Flower',
    thc: '22%',
    price: 45,
    image: 'https://images.unsplash.com/photo-1616690002554-b53821496f45?w=300',
    description: 'Premium indoor grown flower',
    strainType: 'Sativa',
    featured: true,
    newRelease: true
  },
  {
    id: 2,
    name: 'Sunset OG',
    category: 'Flower',
    thc: '25%',
    price: 50,
    image: 'https://images.unsplash.com/photo-1616690001922-700ad8a4a005?w=300',
    description: 'Top-shelf indica strain',
    strainType: 'Indica',
    featured: true,
    popular: true
  },
  {
    id: 3,
    name: 'Tropical Thunder',
    category: 'Vaporizers',
    thc: '85%',
    price: 55,
    image: 'https://images.unsplash.com/photo-1579165466814-e646cfa4a3be?w=300',
    description: 'Premium live resin cartridge',
    strainType: 'Sativa',
    featured: true,
    newRelease: true
  },
  {
    id: 4,
    name: 'Berry Bliss Gummies',
    category: 'Edibles',
    thc: '10mg each',
    price: 25,
    image: 'https://images.unsplash.com/photo-1617627191898-1408bf607b4d?w=300',
    description: '10-pack fruit gummies',
    strainType: 'Hybrid',
    popular: true,
    staffPick: true
  },
  {
    id: 5,
    name: 'Classic Pre-Roll Pack',
    category: 'Pre-Rolls',
    thc: '20%',
    price: 35,
    image: 'https://images.unsplash.com/photo-1616690002206-1aeddb857a4d?w=300',
    description: '5-pack premium pre-rolls',
    strainType: 'Hybrid',
    popular: true
  },
  {
    id: 6,
    name: 'Live Resin Diamond',
    category: 'Concentrates',
    thc: '92%',
    price: 65,
    image: 'https://images.unsplash.com/photo-1616690002494-c8cbe7735682?w=300',
    description: 'Ultra-premium concentrate',
    strainType: 'Indica',
    featured: true,
    staffPick: true
  },
  {
    id: 7,
    name: 'Sativa Supreme',
    category: 'Flower',
    thc: '24%',
    price: 48,
    image: 'https://images.unsplash.com/photo-1616690002554-b53821496f45?w=300',
    description: 'Energizing sativa blend',
    strainType: 'Sativa',
    newRelease: true
  },
  {
    id: 8,
    name: 'Relaxation Vape',
    category: 'Vaporizers',
    thc: '80%',
    price: 50,
    image: 'https://images.unsplash.com/photo-1599177749654-b8f5fe0b016a?w=300',
    description: 'Calming indica cartridge',
    strainType: 'Indica',
    staffPick: true
  }
];

export const faqs = [
  {
    id: 1,
    question: 'What are your hours of operation?',
    answer:
      'Monday through Wednesday: 7 AM to 9 PM ET. Thursday through Saturday: 7 AM to 10 PM ET. Sunday: 8 AM to 8 PM ET.'
  },
  {
    id: 2,
    question: 'Do you offer delivery?',
    answer: 'Yes! We offer same-day delivery throughout The Hamptons. Delivery fees vary by location and order size.'
  },
  {
    id: 3,
    question: 'What payment methods do you accept?',
    answer: 'We accept cash, debit cards, and select digital payment methods. ATM available on-site.'
  },
  {
    id: 4,
    question: 'Is parking available?',
    answer: 'Yes, free parking is available at our Southampton location.'
  },
  {
    id: 5,
    question: 'Do I need a medical card?',
    answer: 'No, we serve both medical and recreational customers 21+.'
  }
];
